export enum CourseType {

    A = "Advanced Training",
    G = "Basic Training/Orientation Course",
    M = "In-mission/In-service Training",
    P = "Pre-deployment Training",
    R = "Pre-posting Training",
    S = "Specialised Training",
    X = "Safety and Security Training"
    
}